export default __webpack_public_path__ + "static/media/image8.a56673c5.jpg";